import type { ComponentPropsWithoutRef, ElementType } from 'react';

type Props<T extends ElementType> = {
  as?: T;
  html?: string | null;
  className?: string;
} & Omit<
  ComponentPropsWithoutRef<T>,
  'as' | 'html' | 'className' | 'children' | 'dangerouslySetInnerHTML'
>;

/**
 * HTML inline (sin `<p>` envolvente como `Prose`). Pensado para campos
 * Strapi string donde el editor puede usar `<mark>`, `<strong>`, etc.
 */
export const RichInline = <T extends ElementType = 'span'>({
  as,
  html,
  className,
  ...rest
}: Props<T>) => {
  const HTMLTag = (as || 'span') as ElementType;
  if (!html) return null;
  return (
    <HTMLTag
      {...rest}
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

RichInline.displayName = 'RichInline';
